import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const getAllBlogs = async (pageNumber, blogsPerPage) => {
  const response = await axios({
    method: "get",
    url: baseurl + `/getBlogs?page=${pageNumber}&limit=${blogsPerPage}`,
  });

  return response.data.data;
};

export const getBlogDetails = async (id) => {
  const response = await axios({
    method: "get",
    url: baseurl + `/getSingleBlog?blogId=${id}`,
  });
  return response.data;
};
